const updateTargets = (event) => {
	let currentLine;
	let nextLine;

	// Updates currentLine and nextLine based on what text line is currently animating
	if (event.currentTarget === document.querySelector(".animated-text:nth-of-type(1)")) {
		currentLine = document.querySelector(".animated-text:nth-of-type(2)");
		nextLine = document.querySelector(".animated-text:nth-of-type(3)");
	} else if (event.currentTarget === document.querySelector(".animated-text:nth-of-type(2)")) {
		currentLine = document.querySelector(".animated-text:nth-of-type(3)");
		nextLine = document.querySelector(".animated-text:nth-of-type(1)");
	} else if (event.currentTarget === document.querySelector(".animated-text:nth-of-type(3)")) {
		currentLine = document.querySelector(".animated-text:nth-of-type(1)");
		nextLine = document.querySelector(".animated-text:nth-of-type(2)");
	}

	return { currentLine, nextLine };
};

const handleAnimation = (currentLine, nextLine) => {
	// "Hold" triggers the "header-videp-hold" so we can use "onanimationend" and we can avoid timeouts
	currentLine.classList.replace("show", "hold");
	currentLine.addEventListener(
		"animationend",
		() => {
			// Once the hold animation is done playing, we begin to hide the current line
			currentLine.addEventListener(
				"animationstart",
				(event) => {
					// Once the hiding animation starts playing, we trigger the animation for the next line since they should happen together
					nextLine.classList.remove("hide");
					nextLine.classList.add("show");

					// Call updateTargets to move our currentLine and nextLine pointers to the correct element
					({ currentLine, nextLine } = updateTargets(event));

					// Begin the process all over again
					currentLine.addEventListener(
						"animationend",
						() => handleAnimation(currentLine, nextLine),
						{ once: true }
					);
				},
				{ once: true }
			);
			currentLine.classList.replace("hold", "hide");
		},
		{ once: true }
	);
};
export const headerVideoTextAnimation = () => {
	const animatedText = document.querySelector(".header-title.animated");
	if (animatedText) {
		const lineOne = animatedText.querySelector(".animated-text:nth-of-type(1)");
		const lineTwo = animatedText.querySelector(".animated-text:nth-of-type(2)");

		animatedText.classList.add("show");

		lineOne.addEventListener("animationend", () => handleAnimation(lineOne, lineTwo), {
			once: true
		});
		lineOne.classList.add("show");
	}
};
